import React, { useEffect, useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { CustomButton } from "../../components/CustomButton";
import { Text } from "../../components/Text";
import "./OfficeHours.css";
import { useDispatch } from "react-redux";
import { addOfficeTime, getOfficeTimes } from "../../reducers/officetimeSlice";
import { useLayout } from "../../context/LayoutContext";
import * as Messag from "../../config/ToastMessage";
import Loader from "../../components/Loader";

const OfficeHours = ({ onHile, officeTime }) => {
  const { toast } = useLayout();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [availability, setAvailability] = useState({
    sunday: { isAvailable: false, startTime: "00:00:00", endTime: "00:00:00" },
    monday: { isAvailable: false, startTime: "00:00:00", endTime: "00:00:00" },
    tuesday: { isAvailable: false, startTime: "00:00:00", endTime: "00:00:00" },
    wednesday: {
      isAvailable: false,
      startTime: "00:00:00",
      endTime: "00:00:00",
    },
    thursday: {
      isAvailable: false,
      startTime: "00:00:00",
      endTime: "00:00:00",
    },
    friday: { isAvailable: false, startTime: "00:00:00", endTime: "00:00:00" },
    saturday: {
      isAvailable: false,
      startTime: "00:00:00",
      endTime: "00:00:00",
    },
  });
  useEffect(() => {
    const updatedAvailability = { ...availability };
    const dayNames = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    officeTime &&
      officeTime.forEach((item) => {
        const dayName = dayNames[item.day];
        updatedAvailability[dayName] = {
          isAvailable: true,
          startTime: item.startTime,
          endTime: item.endTime,
        };
      });
    setAvailability(officeTime ? updatedAvailability : availability);
  }, [officeTime]);

  const handleSwitchChange = (day) => {
    setAvailability((prevState) => ({
      ...prevState,
      [day]: { ...prevState[day], isAvailable: !prevState[day].isAvailable },
    }));
  };
  const handleStartTimeChange = (day, time) => {
    const formattedTime = `${time}:00`;
    setAvailability((prevState) => ({
      ...prevState,
      [day]: { ...prevState[day], startTime: formattedTime },
    }));
  };
  const handleEndTimeChange = (day, time) => {
    const formattedTime = `${time}:00`;
    setAvailability((prevState) => ({
      ...prevState,
      [day]: { ...prevState[day], endTime: formattedTime },
    }));
  };

  const handleSave = () => {
    setLoading(true);
    const officeTimes = Object.keys(availability).reduce((acc, day, index) => {
      if (availability[day].isAvailable) {
        acc.push({
          day: index,
          startTime: availability[day].startTime,
          endTime: availability[day].endTime,
        });
      }
      return acc;
    }, []);

    let officeData = {
      officeTimesData: officeTimes,
    };
    dispatch(addOfficeTime(officeData))
      .unwrap()
      .then((res) => {
        let Message_Success = Messag.Add_office_Time_ToastSuccessMessage;
        toast.current.show({
          severity: "success",
          detail: Message_Success,
        });
        onHile();
        setLoading(false);
      })
      .catch((err) => {
        toast.current.show({ severity: "error", detail: err.response.data });
        setLoading(false);
      });
  };

  return (
    <div className="office-hours-container">
      <Loader visible={loading}/>
      <div className="mx-2 mb-2">
        <Text type={"heading"}>Set Office Hours</Text>
      </div>
      <div className="mx-2">
        <Text type={"sub-heading"}>
          Define your availability and manage quick notes for out-of-office
          hours
        </Text>
      </div>
      <div className="days-container mt-4">
        {Object.keys(availability).map((day) => (
          <div key={day} className="day-row">
            <InputSwitch
              checked={availability[day].isAvailable}
              onChange={() => handleSwitchChange(day)}
              className={`${
                availability[day].isAvailable ? "custom-enabled" : ""
              }`}
            />
            <div className="day-name mx-3">
              {day.charAt(0).toUpperCase() + day.slice(1)}
            </div>

            {!availability[day].isAvailable && (
              <div className="closed-label">Closed</div>
            )}

            {availability[day].isAvailable && (
              <div className="time-inputs">
                <input
                  type="time"
                  value={availability[day].startTime.slice(0, 5)}
                  onChange={(e) => handleStartTimeChange(day, e.target.value)}
                  className="time-picker"
                />
                <div className="mx-2">
                  <Text type={"heading"}>{"to"}</Text>
                </div>
                <input
                  type="time"
                  value={availability[day].endTime.slice(0, 5)}
                  onChange={(e) => handleEndTimeChange(day, e.target.value)}
                  className="time-picker"
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="buttons-container flex justify-end">
        <CustomButton
          label="Cancel"
          onClick={onHile}
          className="p-button-danger"
          varient="outline"
        />
        <CustomButton
          label="Save"
          onClick={handleSave}
          className="p-button-success"
        />
      </div>
    </div>
  );
};

export default OfficeHours;
